import React from 'react'
import { Box, Flex } from 'rebass'
import { StaticQuery, graphql } from 'gatsby'

import Title from './Title'
import UprightLink from './UprightLink'

const PreorderBlock = ({ links }) => (
  <Box css={{ textAlign: 'center' }}>
    <Title textAlign="center">Order Now</Title>
    <Box mt={4} css={{ maxWidth: 940 }} mx="auto">
      <Flex
        flexDirection={['column', 'row']}
        justifyContent="space-between"
        width={1}
        css={{ display: 'inline-flex' }}
      >
        {links.map(link => (
          <Box mt={8} key={link.title}>
            <UprightLink
              color="black"
              href={link.url}
              rel="noopener"
              target="_blank"
              underlined
            >
              {link.title}
            </UprightLink>
          </Box>
        ))}
      </Flex>
    </Box>
  </Box>
)

export default () => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            purchaseLinks {
              url
              title
            }
          }
        }
      }
    `}
    render={data => {
      return <PreorderBlock links={data.site.siteMetadata.purchaseLinks} />
    }}
  />
)
